import { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import { isAfter } from 'date-fns';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useGetMachineQuery } from '../../../shared/redux/machine';
import { LoadingSkeleton } from './loadingSkeleton';
import { DataField } from '../../../shared/components/dataField';
import { format } from '../../../shared/logic/dates';

export const GpsTab: FC<{id: string}> = ({ id }) => {
  const { data: machine, isLoading } = useGetMachineQuery(id);

  if (!machine || isLoading) return <LoadingSkeleton />;

  return (
    <Box display="flex" flexWrap="wrap" alignItems="stretch" flexDirection="row" gap={2}>
      <DataField label="Smartnett bruker" sx={{ flex: '1 1 40%' }}>
        {machine.gpsData?.referenceUsername || '\u00A0'}
      </DataField>
      <DataField label="Sim kort 1 nummer (mottaker)" sx={{ flex: '1 1 40%' }}>
        {machine.gpsData?.simCardReceiverNumber || '\u00A0'}
      </DataField>
      <DataField label="Sim kort 2 nummer (skjerm)" sx={{ flex: '1 1 40%' }}>
        {machine.gpsData?.simCardScreenNumber || '\u00A0'}
      </DataField>
      <DataField label="Sim kort 1 leverandør" sx={{ flex: '1 1 40%' }}>
        {machine.gpsData?.simCardProvider || '\u00A0'}
      </DataField>
      <DataField
        label="Neste CE godkjennelse"
        sx={{ flex: '1 1 40%' }}
      >
        <Box display="flex" gap={1} alignItems="center" color="black">

          {!machine.nextCertificationDate
            ? '\u00A0'
            : format(new Date(machine.nextCertificationDate), 'dd.MM.yyyy')}
          {machine.nextCertificationDate && isAfter(new Date(), new Date(machine.nextCertificationDate))
            ? (
              <Tooltip
                title="Neste service"
                followCursor
                placement="right-start"
                enterDelay={300}
                enterNextDelay={300}
                arrow
              >
                <EventBusyIcon color="error" sx={{ alignSelf: 'center', fontSize: '25px' }} />
              </Tooltip>
            )
            : null}
        </Box>
      </DataField>
    </Box>
  );
};
